// src/views/Dashboard/Repositories/Opcao3.js
import React, { useState } from 'react';
import {
  Box, Text, Flex, Avatar, Input, useColorMode, IconButton, Checkbox, Button,
} from '@chakra-ui/react';
import { FiSend } from 'react-icons/fi';

function Opcao3() {
  const { colorMode } = useColorMode();

  // Dados falsos simulando conversas e mensagens
  const conversas = [
    { id: 1, nome: 'Contato 1', ultimaMensagem: 'Oi, tudo bem?', mensagens: [
      { id: 1, texto: 'Oi, como você está?', enviada: false },
      { id: 2, texto: 'Estou bem, e você?', enviada: true },
      { id: 3, texto: 'Estou ótima, obrigado por perguntar!', enviada: false },
    ]},
    { id: 2, nome: 'Contato 2', ultimaMensagem: 'Vamos nos encontrar hoje?', mensagens: [
      { id: 1, texto: 'Quando você estará disponível?', enviada: false },
      { id: 2, texto: 'Podemos nos encontrar à tarde.', enviada: true },
      { id: 3, texto: 'Perfeito, vejo você às 14h.', enviada: false },
    ]},
    { id: 3, nome: 'Contato 3', ultimaMensagem: 'Como está o projeto?', mensagens: [
      { id: 1, texto: 'O projeto está quase finalizado.', enviada: true },
      { id: 2, texto: 'Ótimo, quando podemos revisar?', enviada: false },
      { id: 3, texto: 'Amanhã pela manhã seria bom.', enviada: true },
    ]},
    { id: 4, nome: 'Contato 4', ultimaMensagem: 'Você viu isso?', mensagens: [
      { id: 1, texto: 'Sim, parece muito interessante!', enviada: true },
      { id: 2, texto: 'Precisamos discutir isso.', enviada: false },
    ]},
    { id: 5, nome: 'Contato 5', ultimaMensagem: 'Feliz aniversário!', mensagens: [
      { id: 1, texto: 'Obrigado! Agradeço muito.', enviada: true },
      { id: 2, texto: 'Espero que você tenha um ótimo dia.', enviada: false },
    ]},
    { id: 6, nome: 'Contato 6', ultimaMensagem: 'Posso ligar agora?', mensagens: [
      { id: 1, texto: 'Agora não posso atender, mas podemos falar mais tarde.', enviada: true },
    ]},
  ];

  // Estado para armazenar a conversa ativa
  const [conversaAtiva, setConversaAtiva] = useState(conversas[0]);
  const [conversasSelecionadas, setConversasSelecionadas] = useState([]);

  const selecionarConversa = (conversa) => {
    setConversaAtiva(conversa); // Define a conversa selecionada
  };

  const toggleSelecaoConversa = (id) => {
    setConversasSelecionadas((prevState) =>
      prevState.includes(id)
        ? prevState.filter((conversaId) => conversaId !== id)
        : [...prevState, id]
    );
  };

  return (
    <Flex
      h="100vh"
      bg={colorMode === 'light' ? 'gray.100' : 'gray.800'}
    >
      {/* Lista de conversas à esquerda */}
      <Box
        w="30%"
        p={4}
        bg={colorMode === 'light' ? 'gray.200' : 'gray.900'}
        borderRightWidth="1px"
        borderColor={colorMode === 'light' ? 'gray.300' : 'gray.600'}
        overflowY="auto"
      >
        <Flex justifyContent="space-between" mb={4}>
          <Text fontSize="2xl" fontWeight="bold">
            Conversas
          </Text>
          <Button
            colorScheme="blue"
            disabled={conversasSelecionadas.length === 0} // Habilita/desabilita o botão
          >
            Reprocessar
          </Button>
        </Flex>

        {/* Exibindo cada conversa com checkbox */}
        {conversas.map((conversa) => (
          <Flex
            key={conversa.id}
            align="center"
            p={2}
            mb={2}
            _hover={{ bg: 'gray.300', cursor: 'pointer' }}
            bg={conversaAtiva.id === conversa.id ? 'gray.400' : (colorMode === 'light' ? 'gray.100' : 'gray.700')}
            borderRadius="md"
            onClick={() => selecionarConversa(conversa)} // Altera a conversa ativa ao clicar
          >
            <Checkbox
              mr={3}
              isChecked={conversasSelecionadas.includes(conversa.id)}
              onChange={() => toggleSelecaoConversa(conversa.id)}
            />
            <Avatar name={conversa.nome} mr={3} />
            <Box>
              <Text fontWeight="bold">{conversa.nome}</Text>
              <Text fontSize="sm" color="gray.500">
                {conversa.ultimaMensagem}
              </Text>
            </Box>
          </Flex>
        ))}
      </Box>

      {/* Área de chat à direita */}
      <Flex
        w="70%"
        direction="column"
        justify="space-between"
        p={4}
        bg={colorMode === 'light' ? 'white' : 'gray.700'}
      >
        {/* Cabeçalho do chat */}
        <Box pb={4} borderBottomWidth="1px" borderColor="gray.300">
          <Flex align="center">
            <Avatar name={conversaAtiva.nome} mr={3} />
            <Text fontSize="xl" fontWeight="bold">{conversaAtiva.nome}</Text>
          </Flex>
        </Box>

        {/* Mensagens */}
        <Box flex={1} overflowY="auto" my={4}>
          {/* Exibindo cada mensagem da conversa ativa */}
          {conversaAtiva.mensagens.map((mensagem) => (
            <Box key={mensagem.id} mb={4} textAlign={mensagem.enviada ? 'right' : 'left'}>
              <Text
                p={3}
                bg={mensagem.enviada ? 'blue.500' : 'gray.200'}
                color={mensagem.enviada ? 'white' : 'black'}
                borderRadius="md"
                alignSelf={mensagem.enviada ? 'flex-end' : 'flex-start'}
                w="fit-content"
                ml={mensagem.enviada ? 'auto' : '0'}
              >
                {mensagem.texto}
              </Text>
            </Box>
          ))}
        </Box>

        {/* Caixa de mensagem */}
        <Flex mt={4}>
          <Input
            placeholder="Digite uma mensagem..."
            mr={2}
            bg={colorMode === 'light' ? 'gray.200' : 'gray.600'}
          />
          <IconButton
            icon={<FiSend />}
            colorScheme="blue"
            aria-label="Enviar"
          />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default Opcao3;
